import { homeRepository } from '@/repositories/Index'

class HomeService {
	// 获取广告活动种类相关契约
	async getActivityKindsFn(params: any) {
		const res = await homeRepository.getActivityKinds(params)
		return res
	}

	//查询字符串配置
	async queryStringConfigurationFn(params: any) {
		const res = await homeRepository.queryStringConfiguration(params)
		return res
	}

	async getPuffImage(params: any) {
		const res = await homeRepository.getPuffImage(params)
		return res
	}

	async closeRemind(params: any) {
		const res = await homeRepository.closeRemind(params)
		return res
	}

	async steerPopUps(params: any) {
		const res = await homeRepository.steerPopUps(params)
		return res
	}

	async saveRetainedCapital(params: any) {
		const res = await homeRepository.saveRetainedCapital(params)
		return res
	}

	async queryRetainedCapitalList(params: any) {
		const res = await homeRepository.queryRetainedCapitalList(params)
		return res
	}

	async getSurveyInfo(params: any) {
		const res = await homeRepository.getSurveyInfo(params)
		return res
	}
	async saveSurveyContent(params: any) {
		const res = await homeRepository.saveSurveyContent(params)
		return res
	}

	async getPromotionHotelDetail(params: any) {
		const res = await homeRepository.getPromotionHotelDetail(params)
		return res
	}

	async applyPromotionHotel(params: any) {
		const res = await homeRepository.applyPromotionHotel(params)
		return res
	}
}

export default HomeService
